export default function Mark() {
    return (
        <svg width="73" height="97" viewBox="0 0 73 97" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.8611 76.5222H72.75V97H0V57.6611H18.8611V76.5222Z" fill="#E0FEDE"/>
            <path d="M46.8835 57.6607H18.8613V38.2607H46.8835V57.6607Z" fill="#E0FEDE"/>
            <path d="M72.7495 20.4778H40.9551V0H72.7495V20.4778Z" fill="#E0FEDE"/>
        </svg>
    )
}


